//
// Module for the Group Membership Listing page in the Security section
//
rs.module("security/listings/groupmembership",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);

            // Show the loading spinner when the View button is clicked and the form is submitted
            form.on("formdata", function (e) {
                loadingSpinner.show();
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);